export enum WorkspaceCreationStageType {
    Creating = "Creating",
    Configuring = "Configuring",
    None = "None"
}